import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss',
})
export class ButtonComponent {
	@Input() label: string;
	@Input() colorBtn: string = '';
	@Input() colorBtnText: string = '';
	@Output() onClick = new EventEmitter<any>();

	constructor() {}

	onClickButton(event: Event) {
		this.onClick.emit(event);
	}
}
